import { api } from "./dataService";

export const fetchSourceConfigs = async () => {
  return (await api.get("data/import-sources")).data;
};

export const fetchSourceConfig = async (id) => {
  return (await api.get(`data/import-sources/${id}`)).data;
};

export const createSourceConfig = async (payload) => {
  return (await api.post("data/import-sources", payload)).data;
};

export const updateSourceConfig = async (id, payload) => {
  return (await api.patch(`data/import-sources/${id}`, payload)).data;
};

export const deleteSourceConfig = async (id) => {
  await api.delete(`data/import-sources/${id}`);
};

export const runSourceConfig = async (id) => {
  return (await api.post(`data/import-sources/${id}/run`)).data;
};
